<div class="modal-header">
    <h4 class="modal-title" [innerHtml]="title"></h4>
</div>
<div class="modal-body" >
    <p [innerHtml]="message"></p>
    <edl-floating-label-container label="Additional Message" for="additionalMessage">
        <textarea id="additionalMessage" [(ngModel)]="additionalText" rows="5" class="form-control"></textarea>
    </edl-floating-label-container>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="activeModal.close(additionalText)">{{yesButtonText ?? 'Yes'}}</button>
    <button type="button" class="btn btn-info" (click)="activeModal.dismiss('cancel')">{{noButtonText ?? 'No'}}</button>
</div>